import { Model } from "@nozbe/watermelondb";
import { OFFLINE_RESOURCES_TABLE } from "../schema";

export type OfflineResourceSnapshot = {
  cacheKey: string;
  scope: string;
  path: string;
  payload: string;
  cachedAt: number;
};

export class OfflineResource extends Model {
  static table = OFFLINE_RESOURCES_TABLE;

  get cacheKey(): string {
    return String(this._getRaw("cache_key") ?? "");
  }

  get scope(): string {
    return String(this._getRaw("scope") ?? "");
  }

  get path(): string {
    return String(this._getRaw("path") ?? "");
  }

  get payload(): string {
    return String(this._getRaw("payload") ?? "");
  }

  get cachedAt(): number {
    return Number(this._getRaw("cached_at") ?? 0);
  }

  applySnapshot(snapshot: OfflineResourceSnapshot): void {
    this._setRaw("cache_key", snapshot.cacheKey);
    this._setRaw("scope", snapshot.scope);
    this._setRaw("path", snapshot.path);
    this._setRaw("payload", snapshot.payload);
    this._setRaw("cached_at", snapshot.cachedAt);
  }
}
